import { Grid } from "antd-mobile";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { WinCustomNumberInput } from "..";
import { thousandFormat } from "../../plugins/numberFormat";
import { envChangeType, envType } from "../../plugins/utils";
import styles from "./style.module.scss";

const WinBetModalContent = ({
  colorStyle = {},
  totalMoney,
  setTotalMoney = () => {},
  showOdds = false,
  odds = [],
}) => {
  const { t } = useTranslation();
  const [selectedMoney, setSelectedMoney] = useState();

  const selectedMoneyStyle = (item) => {
    if (selectedMoney === item) {
      return { color: "#ffff", ...colorStyle };
    }
    return {};
  };

  const onSelectedMoney = (money) => {
    setSelectedMoney(money);
    setTotalMoney(money);
  };

  const customInputStyle = {
    "--placeholder-color": "rgba(51, 51, 51, 0.5)",
    boxShadow: "none",
    backgroundColor: "#eeee",
    "--color": "#333",
    border: "1px solid transparent",
  };

  const renderOddsList = () => {
    return odds.map((_odds, index) => {
      return (
        <div className={`${styles.oddsItem}`}>
          <div className={styles.oddIndex} style={colorStyle}>
            {index + 1}
          </div>
          <div className={styles.oddContent}>
            =<span>{`${_odds}x`}</span>
          </div>
        </div>
      );
    });
  };

  const renderOdds = () => {
    if (showOdds === false || odds.length <= 0) return;
    return (
      <div className={styles.oddsContainer}>
        {`${t("win.color.rule.odds")}：`}
        {renderOddsList()}
      </div>
    );
  };

  return (
    <>
      {renderOdds()}
      <div className={styles.moneyTitle}>{t("win.betpopup.betAmount")}</div>
      <WinCustomNumberInput
        placeholder={t("win.betpopup.placeholder")}
        inputStyle={customInputStyle}
        value={totalMoney}
        onChange={(val) => {
          setTotalMoney(val);
          setSelectedMoney({ key: val.toString(), value: val });
        }}
      />
      <div className={styles.moneyTitle}>{t("win.betpopup.moneytitle")}</div>
      <Grid columns={6} gap={12}>
        {envChangeType("REACT_APP_WIN_QUICK_BET_POINT", envType.ARRAY).map((item, index) => {
          return (
            <Grid.Item key={`${item}_${index}`}>
              <div
                onClick={() => onSelectedMoney(item)}
                className={styles.moneySelector}
                style={selectedMoneyStyle(item)}
              >
                {thousandFormat(item)}
              </div>
            </Grid.Item>
          );
        })}
      </Grid>
    </>
  );
};

export default WinBetModalContent;
